// Leaflet (224 KiB) was previously loaded globally in index.html on every
// single page, even though only two components actually use it
// (listing-details, explore-seychelles). This loads it on demand instead -
// the first component that needs it triggers the load; if the user then
// visits the other map page too, this returns the same already-resolved
// promise instead of loading it twice.
let leafletLoadPromise: Promise<void> | null = null;

export function loadLeafletAssets(): Promise<void> {
  // Already loaded (e.g. navigated here from the other map page this session)
  if ((window as any).L) {
    return Promise.resolve();
  }

  if (leafletLoadPromise) {
    return leafletLoadPromise;
  }

  leafletLoadPromise = new Promise<void>((resolve, reject) => {
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = './assets/css/leaflet.min.css';
    document.head.appendChild(cssLink);

    const script = document.createElement('script');
    script.src = './assets/js/leaflet.min.js';
    script.onload = () => resolve();
    script.onerror = () => {
      leafletLoadPromise = null; // allow a retry on next call if this failed
      reject(new Error('Failed to load Leaflet'));
    };
    document.head.appendChild(script);
  });

  return leafletLoadPromise;
}
